module.exports = __webpack_public_path__ + "static/media/baxmusic.288b520c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/baxmusic.webp
// module id = 292
// module chunks = 0